import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Box,
  Card,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  styled,
  TextField,
  FormControl
} from '@mui/material';
import dayjs from 'dayjs';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React from 'react';
import { H4 } from 'app/components/Typography';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useEffect } from 'react';
import { getInvoiceAccountData } from 'app/contexts/reducers/account/accountSlice';
import { convertCustomerId, convertYearId } from 'app/utils/convertId';
import { getSingleCustomerRunningOrder } from 'app/contexts/reducers/transaction/oderSlice';
import { getBookMaster } from 'app/contexts/reducers/bookMaster/bookMasterSlice';
import CustomerRunningOrder from './CustomerRunningOrder';
import { fetchOutwardData } from '../helper/fetchOutwardDetails';
import { genrateInvoice } from 'app/contexts/reducers/transaction/invoiceSlice';
import { indianStates } from '../helper/stateData';
import { orderType } from '../helper/orderTypeData';
import { calculateGST } from '../helper/invoiceTotal';

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: { padding: '16px !important' }
}));

const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'flex-start',
  '& small': { color: theme.palette.text.secondary },
  '& .icon': { opacity: 0.6, fontSize: '44px', color: theme.palette.primary.main }
}));

const CreateInvoice = ({ handleApiCall, apiCall }) => {
  const dispatch = useDispatch();

  const { isInvoiceCustomerSuccess, invoiceCustomerData } = useSelector((state) => state.account);
  const { isSingleCustomerRunningOrderSuccess, singleCustomerRunningOrder } = useSelector(
    (state) => state.order
  );

  const { bookYear, isBookMasterSuccess, bookMasterData } = useSelector(
    (state) => state.bookMaster
  );
  const intialInvoiceData = {
    bookNumber: '',
    customerName: '',
    customerId: null,
    gstNumber: null,
    panNumber: null,
    usedWeight: '',
    selfWeight: '',
    usedPcs: '',
    labourChargePerPcs: '',
    labourCharge: '',
    purity: '',
    diamondCaratPrice: '',
    diamondPrice: '',
    productPrice: 0,
    extraCost: 0,
    mobileNumber: '',
    orderType: 'Self',
    state: '',
    address: '',
    email: '',
    date: dayjs(),
    remark: '',
    quantity: 0,
    subTotal: 0,
    cgstPercentage: 0,
    cgstValue: 0,
    sgstPercentage: 0,
    sgstValue: 0,
    igstPercentage: 0,
    igstValue: 0,
    dcgstPercentage: 0,
    dcgstValue: 0,
    dsgstPercentage: 0,
    dsgstValue: 0,
    lcgstPercentage: 0,
    lcgstValue: 0,
    lsgstPercentage: 0,
    lsgstValue: 0,
    digstPercentage: 0,
    digstValue: 0,
    ligstPercentage: 0,
    ligstValue: 0,
    extraCostCgstPercentage: 0,
    extraCostCgstValue: 0,
    extraCostSgstPercentage: 0,
    extraCostSgstValue: 0,
    extraCostIgstPercentage: 0,
    extraCostIgstValue: 0,
    roundOff: '',
    total: 0,
    orders: []
  };

  const [createInvoice, setCreateInvoice] = useState(intialInvoiceData);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState();
  const [accountCustomerData, setAccountCustomerData] = useState([]);
  const [customerRunningOrder, setCustomerRunningOrder] = useState([]);
  const [dataError, setDataError] = useState({
    customerNameError: false,
    gstNumberError: false,
    panNumberError: false,
    orderTypeError: false,
    customerIdError: false,
    usedPcsError: false,
    usedWeightError: false,
    labourPerPcsError: false,
    labourChargeError: false,
    quantityError: false,
    extraCostError: false,
    totalError: false,
    subTotalError: false
  });
  const [selectedOrderDetails, setSelectedOrderDetails] = useState([]);

  const [callYear, setCallYear] = useState(false);

  useEffect(() => {
    const quantity = selectedOrderDetails.length;
    (async () => {
      try {
        // Assuming 'orders' and 'dispatch' are available within the component
        const result = await fetchOutwardData(selectedOrderDetails, dispatch);
        setCreateInvoice((prevCreateOrder) => ({
          ...prevCreateOrder,
          quantity,
          usedPcs: result.piecesSum,
          selfWeight: result.weightSum,
          usedWeight: result.totalWeight,
          productPrice: result.totalProductPrice
        }));
        setDataError((prevDataError) => ({
          ...prevDataError,
          usedPcsError: false,
          usedWeightError: false,
          quantityError: false
        }));
        // Further processing with the result if needed
      } catch (error) {
        console.error('Error:', error);
      }
    })();
    // setCreateInvoice((prevCreateOrder) => ({ ...prevCreateOrder, quantity }));
  }, [selectedOrderDetails, dispatch]);
  useEffect(() => {
    dispatch(getInvoiceAccountData());
    dispatch(getBookMaster());
  }, [dispatch]);
  useEffect(() => {
    createInvoice.customerId &&
      dispatch(getSingleCustomerRunningOrder({ customerId: createInvoice.customerId }));
    setSelectedOrderDetails([]);
  }, [dispatch, createInvoice.customerId, apiCall]);
  useEffect(() => {
    const totalPieces = Number(createInvoice.usedPcs) > 0 ? Number(createInvoice.usedPcs) : 1;
    const labourCharge = totalPieces * Number(createInvoice.labourChargePerPcs);
    setCreateInvoice((prevCreateOrder) => ({ ...prevCreateOrder, labourCharge }));
    setDataError((prevDataError) => ({ ...prevDataError, labourChargeError: false }));
  }, [createInvoice.labourChargePerPcs, createInvoice.usedPcs]);

  useEffect(() => {
    const totalSelfWeight =
      Number(createInvoice.selfWeight) > 0 ? Number(createInvoice.selfWeight) : 1;
    const diamondPrice = totalSelfWeight * Number(createInvoice.diamondCaratPrice);
    setCreateInvoice((prevCreateOrder) => ({ ...prevCreateOrder, diamondPrice }));
  }, [createInvoice.diamondCaratPrice, createInvoice.selfWeight]);

  useEffect(() => {
    const total =
      Number(createInvoice.diamondPrice) +
      Number(createInvoice.labourCharge) +
      Number(createInvoice.productPrice);
    setCreateInvoice((prevCreateOrder) => ({ ...prevCreateOrder, total, subTotal: total }));
    setDataError((prevDataError) => ({
      ...prevDataError,
      totalError: false,
      subTotalError: false
    }));
  }, [createInvoice.diamondPrice, createInvoice.labourCharge, createInvoice.productPrice]);

  useEffect(() => {
    if (isSingleCustomerRunningOrderSuccess) {
      if (Number(singleCustomerRunningOrder.data.code) === 200) {
        setCustomerRunningOrder(singleCustomerRunningOrder.data.data);
      } else {
        setCustomerRunningOrder([]);
      }
    }
  }, [singleCustomerRunningOrder, isSingleCustomerRunningOrderSuccess]);
  useEffect(() => {
    isInvoiceCustomerSuccess && setAccountCustomerData(invoiceCustomerData.data.data);

    isBookMasterSuccess && getBookId();
    // eslint-disable-next-line
  }, [isInvoiceCustomerSuccess, isBookMasterSuccess, invoiceCustomerData, bookMasterData]);

  useEffect(() => {
    getBookId();
    // eslint-disable-next-line
  }, [callYear]);
  // -------------------calculate-GST--------------------
  useEffect(() => {
    async function fetchData() {
      const { orderType, state, subTotal, labourCharge, diamondPrice, extraCost } = createInvoice;
      const gstAddedValue = await calculateGST(
        orderType,
        state,
        subTotal,
        diamondPrice,
        labourCharge,
        extraCost
      );
      const {
        sgstPercentage,
        cgstPercentage,
        igstPercentage,
        dcgstPercentage,
        dsgstPercentage,
        lcgstPercentage,
        lsgstPercentage,
        digstPercentage,
        ligstPercentage,
        extraCostCGSTPercentage,
        extraCostSGSTPercentage,
        extraCostIGSTPercentage,
        sgstValue,
        cgstValue,
        igstValue,
        dcgstValue,
        dsgstValue,
        lcgstValue,
        lsgstValue,
        digstValue,
        ligstValue,
        extraCostCGSTValue,
        extraCostSGSTValue,
        extraCostIGSTValue,
        extraCostWithGST,
        totalValueWithGST,
        roundedOffValue
      } = gstAddedValue;
      setCreateInvoice({
        ...createInvoice,
        cgstPercentage: parseFloat(parseFloat(cgstPercentage).toFixed(2)),
        cgstValue: parseFloat(parseFloat(cgstValue).toFixed(2)),
        sgstPercentage: parseFloat(parseFloat(sgstPercentage).toFixed(2)),
        sgstValue: parseFloat(parseFloat(sgstValue).toFixed(2)),
        igstPercentage: Number(igstPercentage),
        igstValue: parseFloat(parseFloat(igstValue).toFixed(2)),
        dcgstPercentage: parseFloat(parseFloat(dcgstPercentage).toFixed(2)),
        dcgstValue: parseFloat(parseFloat(dcgstValue).toFixed(2)),
        dsgstPercentage: parseFloat(parseFloat(dsgstPercentage).toFixed(2)),
        dsgstValue: parseFloat(parseFloat(dsgstValue).toFixed(2)),
        lcgstPercentage: parseFloat(parseFloat(lcgstPercentage).toFixed(2)),
        lcgstValue: parseFloat(parseFloat(lcgstValue).toFixed(2)),
        lsgstPercentage: parseFloat(parseFloat(lsgstPercentage).toFixed(2)),
        lsgstValue: parseFloat(parseFloat(lsgstValue).toFixed(2)),
        digstPercentage: parseFloat(parseFloat(digstPercentage).toFixed(2)),
        digstValue: parseFloat(parseFloat(digstValue).toFixed(2)),
        ligstPercentage: parseFloat(parseFloat(ligstPercentage).toFixed(2)),
        ligstValue: parseFloat(parseFloat(ligstValue).toFixed(2)),
        extraCostCgstPercentage: parseFloat(parseFloat(extraCostCGSTPercentage).toFixed(2)),
        extraCostSgstPercentage: parseFloat(parseFloat(extraCostSGSTPercentage).toFixed(2)),
        extraCostIgstPercentage: parseFloat(parseFloat(extraCostIGSTPercentage).toFixed(2)),
        extraCostCgstValue: parseFloat(parseFloat(extraCostCGSTValue).toFixed(2)),
        extraCostSgstValue: parseFloat(parseFloat(extraCostSGSTValue).toFixed(2)),
        extraCostIgstValue: parseFloat(parseFloat(extraCostIGSTValue).toFixed(2)),
        extraCostGstValue: parseFloat(parseFloat(extraCostWithGST).toFixed(2)),
        total: totalValueWithGST,
        roundOff: roundedOffValue
      });
    }

    fetchData();
    // eslint-disable-next-line
  }, [
    createInvoice.orderType,
    createInvoice.state,
    createInvoice.subTotal,
    createInvoice.extraCost
  ]);

  // const handleDateChange = (date) => setDate(date);
  const getBookId = () => {
    const yearId = convertYearId(bookMasterData?.data?.data, bookYear);
    if (yearId) {
      setCreateInvoice((prev) => ({ ...prev, bookId: yearId.id, bookNumber: bookYear }));
    } else {
      setCreateInvoice((prev) => ({ ...prev, bookId: null, bookNumber: bookYear }));
    }
  };
  function handleClickError() {
    setSuccessOpen(false);
    setErrorOpen(true);
  }
  function handleClickSuccess(message) {
    setErrorOpen(false);
    setSuccessMessage(message);
    setSuccessOpen(true);
  }
  function handleSnakeBarClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessOpen(false);
    setErrorOpen(false);
  }
  const handleStateSelect = async (e) => {
    setCreateInvoice({
      ...createInvoice,
      state: e.target.value
    });
  };
  const handleOrderTypeSelect = async (e) => {
    setCreateInvoice({
      ...createInvoice,
      orderType: e.target.value
    });
    setDataError({ ...dataError, orderTypeError: false });
  };
  const handleCustomerSelect = async (e) => {
    const customerId = await convertCustomerId(accountCustomerData, e.target.value);
    setCreateInvoice({
      ...createInvoice,
      customerId: customerId.id,
      customerName: e.target.value,
      email: customerId.email,
      panNumber: customerId.pan_number,
      address: customerId.address,
      mobileNumber: customerId.mobile_number,
      gstNumber: customerId.gst_number
    });
    setDataError({ ...dataError, customerNameError: false, customerIdError: false });
  };
  const handleBookNameSelect = (e) => {
    const selectedYearName = e.target.value;
    const yearId = convertYearId(bookMasterData?.data?.data, selectedYearName);
    if (yearId) {
      setCreateInvoice((prev) => ({ ...prev, bookId: yearId.id, bookNumber: selectedYearName }));
    } else {
      setCreateInvoice((prev) => ({ ...prev, bookId: null, bookNumber: selectedYearName }));
    }
  };

  const handleCheckboxChange = (detail) => {
    const selectedIndex = selectedOrderDetails.indexOf(detail);

    // If the item is not in the array, add it. Otherwise, remove it.
    const newSelected = [...selectedOrderDetails];

    if (selectedIndex === -1) {
      newSelected.push(detail);
    } else {
      newSelected.splice(selectedIndex, 1);
    }
    // Calculate the extra cost based on the length of the newSelected array
    const extraCostPerItem = 847.46;
    const extraCost = newSelected.length * extraCostPerItem;

    setCreateInvoice({ ...createInvoice, orders: newSelected, extraCost });

    setSelectedOrderDetails(newSelected);
  };

  const handleSubmit = async () => {
    try {
      if (
        createInvoice.bookId &&
        createInvoice.customerName &&
        createInvoice.customerName.length > 0 &&
        createInvoice.customerId &&
        Number(createInvoice.customerId) > 0 &&
        createInvoice.usedWeight &&
        createInvoice.usedPcs &&
        Number(createInvoice.labourChargePerPcs) >= 0 &&
        Number(createInvoice.labourCharge) >= 0 &&
        createInvoice.bookNumber &&
        Number(createInvoice.bookNumber) > 0 &&
        createInvoice.quantity &&
        createInvoice.total &&
        createInvoice.date &&
        createInvoice.subTotal &&
        createInvoice.orders.length > 0
      ) {
        const invoiceDetails = { ...createInvoice };
        const propertiesToConvert = [
          'usedWeight',
          'selfWeight',
          'customerId',
          'usedPcs',
          'labourChargePerPcs',
          'diamondCaratPrice',
          'diamondPrice',
          'labourCharge',
          'productPrice',
          'extraCost',
          'quantity',
          'subTotal',
          'total'
        ];
        propertiesToConvert.forEach((property) => {
          if (invoiceDetails.hasOwnProperty(property)) {
            if (property === 'usedWeight' || property === 'selfWeight') {
              invoiceDetails[property] = parseFloat(
                parseFloat(invoiceDetails[property]).toFixed(3)
              );
            } else {
              invoiceDetails[property] = parseInt(invoiceDetails[property]);
            }
          }
        });
        Object.keys(invoiceDetails).forEach((key) => {
          if (invoiceDetails[key] === '') {
            delete invoiceDetails[key];
          }
        });

        const responseValue = await dispatch(genrateInvoice(invoiceDetails));
        if (!responseValue.hasOwnProperty('error')) {
          handleClickSuccess('Invoice Genrated successfully!!');
          setCreateInvoice(intialInvoiceData);
          setCustomerRunningOrder([]);
          setLoading(false);
          handleApiCall();
          setCallYear((prev) => !prev);
        } else {
          throw responseValue;
        }
      } else {
        if (!createInvoice.bookId) {
          handleClickError();
          setError({ payload: 'Financial year not configured in Book Master. Please contact Admin.' });
          setLoading(false);
          return;
        }
        const validationRules = [
          {
            property: 'customerName',
            condition: createInvoice.customerName <= 0,
            errorKey: 'customerNameError'
          },
          {
            property: 'gstNumber',
            condition: createInvoice.gstNumber <= 0,
            errorKey: 'gstNumberError'
          },
          {
            property: 'panNumber',
            condition: createInvoice.panNumber <= 0,
            errorKey: 'panNumberError'
          },
          {
            property: 'orderType',
            condition: createInvoice.orderType <= 0,
            errorKey: 'orderTypeError'
          },
          {
            property: 'customerId',
            condition: Number(createInvoice.customerId) <= 0,
            errorKey: 'customerIdError'
          },
          {
            property: 'usedWeight',
            condition: Number(createInvoice.usedWeight) <= 0,
            errorKey: 'usedWeightError'
          },
          {
            property: 'usedPcs',
            condition: Number(createInvoice.usedPcs) <= 0,
            errorKey: 'usedPcsError'
          },
          {
            property: 'labourChargePerPcs',
            condition: Number(createInvoice.labourChargePerPcs) < 0,
            errorKey: 'labourPerPcsError'
          },
          {
            property: 'labourCharge',
            condition: Number(createInvoice.labourCharge) < 0,
            errorKey: 'labourChargeError'
          },
          {
            property: 'quantity',
            condition: Number(createInvoice.quantity) <= 0,
            errorKey: 'quantityError'
          },
          {
            property: 'extraCost',
            condition: Number(createInvoice.extraCost) < 0,
            errorKey: 'extraCostError'
          },
          {
            property: 'total',
            condition: Number(createInvoice.total) <= 0,
            errorKey: 'totalError'
          },
          {
            property: 'subTotal',
            condition: Number(createInvoice.subTotal) <= 0,
            errorKey: 'subTotalError'
          }
        ];

        const updatedErrors = validationRules.reduce(
          (errors, rule) => {
            if (rule.condition) {
              errors[rule.errorKey] = true;
            }
            return errors;
          },
          { ...dataError }
        );

        setDataError(updatedErrors);

        handleClickError();
        setError({ payload: 'Please Fill Mandatory Data!' });
        setLoading(false);
      }
    } catch (error) {
      handleClickError();
      setError(error);
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      {' '}
      <Snackbar open={successOpen} autoHideDuration={3000} onClose={handleSnakeBarClose}>
        <Alert
          onClose={handleSnakeBarClose}
          severity='success'
          sx={{ width: '100%' }}
          variant='filled'
        >
          {successMessage}
        </Alert>
      </Snackbar>
      <Snackbar open={errorOpen} autoHideDuration={3000} onClose={handleSnakeBarClose}>
        <Alert
          onClose={handleSnakeBarClose}
          severity='error'
          sx={{ width: '100%' }}
          variant='filled'
        >
          {error?.payload}
        </Alert>
      </Snackbar>
      <Grid container spacing={3} sx={{ mb: '24px' }}>
        <Grid item xs={12} md={12}>
          <StyledCard elevation={6}>
            <H4 sx={{ mb: 2 }}>CREATE INVOICE</H4>
            <Grid container sx={{ marginBottom: 3 }}>
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <InputLabel
                  sx={{ fontSize: '10px' }}
                  error={dataError.customerNameError}
                  required
                  id='accountGroupName'
                >
                  Customer Name
                </InputLabel>

                <Select
                  size='small'
                  sx={{ width: '80%', my: 1 }}
                  variant='standard'
                  labelId='accountGroupName'
                  value={createInvoice.customerName}
                  onChange={handleCustomerSelect}
                  error={dataError.customerNameError}
                >
                  {accountCustomerData.map((data, index) => (
                    <MenuItem value={data.account_name} key={index} id={index}>
                      {data.account_name}
                    </MenuItem>
                  ))}
                </Select>
                <ContentBox>
                  <TextField
                    id='usedPcs'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Used Piece'
                    required
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.usedPcs}
                    error={dataError.usedPcsError}
                    helperText={dataError.usedPcsError ? 'Please Select Order First' : ''}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='labourpiececharge'
                    type='number'
                    margin='dense'
                    size='small'
                    label='Labour/Piece Charge'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.labourChargePerPcs}
                    error={dataError.labourPerPcsError}
                    helperText={
                      dataError.labourPerPcsError ? 'Please Enter Charge Of Per Piece' : ''
                    }
                    onChange={(e) => {
                      setCreateInvoice({ ...createInvoice, labourChargePerPcs: e.target.value });
                      setDataError({ ...dataError, labourPerPcsError: false });
                    }}
                    required
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='purity'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Purity'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.purity}
                    onChange={(e) => {
                      setCreateInvoice({ ...createInvoice, purity: e.target.value });
                    }}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    multiline
                    maxRows={4}
                    id='specialNote'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Special Note'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.remark}
                    onChange={(e) => {
                      setCreateInvoice({ ...createInvoice, remark: e.target.value });
                    }}
                  />
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='cgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='CGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.cgstPercentage}
                      />
                    )}
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='dcgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='D-CGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.dcgstPercentage}
                      />
                    )}
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.toLowerCase() !== 'gujarat' && (
                      <TextField
                        id='igstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='IGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.igstPercentage}
                      />
                    )}
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() !== 'gujarat' && (
                      <TextField
                        id='digstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='D-IGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.digstPercentage}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='cgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='CGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.cgstValue}
                      />
                    )}
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='dcgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='D-CGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.dcgstValue}
                      />
                    )}
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.toLowerCase() !== 'gujarat' && (
                      <TextField
                        id='igstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='IGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.igstValue}
                      />
                    )}
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() !== 'gujarat' && (
                      <TextField
                        id='digstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='D-IGST value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.digstValue}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='extraCostCgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Extra-CGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostCgstPercentage}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='extraCostCgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Extra-CGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostCgstValue}
                      />
                    )}
                </ContentBox>
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <ContentBox>
                  <TextField
                    id='gstNumber'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Gst Number'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.gstNumber}
                    error={dataError.gstNumberError}
                    helperText={dataError.gstNumberError ? 'Please Enter GST Number' : ''}
                    onChange={(e) => {
                      setCreateInvoice({ ...createInvoice, gstNumber: e.target.value });
                      setDataError({ ...dataError, gstNumberError: false });
                    }}
                    required
                  />
                </ContentBox>

                <ContentBox>
                  <TextField
                    id='usedWeight'
                    required
                    type='text'
                    margin='dense'
                    size='small'
                    label='Used Weight'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.usedWeight}
                    error={dataError.usedWeightError}
                    helperText={dataError.usedWeightError ? 'Please Select Order First' : ''}
                  />
                </ContentBox>

                <ContentBox>
                  <TextField
                    id='labourcharge'
                    required
                    type='text'
                    margin='dense'
                    size='small'
                    label='Labour Charge'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.labourCharge}
                    error={dataError.labourChargeError}
                    helperText={dataError.labourChargeError ? 'Please Enter Labour Charge' : ''}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='diamondcaratprice'
                    type='number'
                    margin='dense'
                    size='small'
                    label='Diamond/Carat Price'
                    disabled={Number(createInvoice.selfWeight) === 0 ? true : false}
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.diamondCaratPrice}
                    onChange={(e) => {
                      setCreateInvoice({ ...createInvoice, diamondCaratPrice: e.target.value });
                    }}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='panNumber'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Pan Number'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.panNumber}
                    error={dataError.panNumberError}
                    helperText={dataError.panNumberError ? 'Please Enter Pan Number' : ''}
                    onChange={(e) => {
                      setCreateInvoice({ ...createInvoice, panNumber: e.target.value });
                      setDataError({ ...dataError, panNumberError: false });
                    }}
                    required
                  />
                </ContentBox>

                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='sgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='SGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.sgstPercentage}
                      />
                    )}
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='dsgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='D-SGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.dsgstPercentage}
                      />
                    )}
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() !== 'gujarat' && (
                      <TextField
                        id='ligstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='L-IGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.ligstPercentage}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.replace(/\s+/g, '').toLowerCase() === 'outofstate' && (
                      <TextField
                        id='extraCostIgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Extra-IGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostIgstPercentage}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='sgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='SGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.sgstValue}
                      />
                    )}
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='dsgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='D-SGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.dsgstValue}
                      />
                    )}
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() !== 'gujarat' && (
                      <TextField
                        id='ligstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='L-IGST value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.ligstValue}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.replace(/\s+/g, '').toLowerCase() === 'outofstate' && (
                      <TextField
                        id='extraCostIgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Extra-IGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostIgstValue}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='extraCostSgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Exra-SGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostSgstPercentage}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='extraCostSgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Exra-SGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostSgstValue}
                      />
                    )}
                </ContentBox>
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <InputLabel
                  sx={{ fontSize: '10px' }}
                  error={dataError.orderTypeError}
                  required
                  id='orderType'
                >
                  Order-Type
                </InputLabel>

                <Select
                  size='small'
                  sx={{ width: '80%', my: 1 }}
                  variant='standard'
                  labelId='orderType'
                  value={createInvoice.orderType}
                  onChange={handleOrderTypeSelect}
                  error={dataError.orderTypeError}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200
                      }
                    }
                  }}
                >
                  {orderType.map((data, index) => (
                    <MenuItem value={data} key={index} id={index}>
                      {data}
                    </MenuItem>
                  ))}
                </Select>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{ width: '80%', my: 1 }}
                    label='Date'
                    format='DD/MM/YYYY'
                    value={createInvoice.date}
                    onChange={(newValue) => setCreateInvoice({ ...createInvoice, date: newValue })}
                    slotProps={{ textField: { variant: 'standard' } }}
                  />
                </LocalizationProvider>
                <ContentBox>
                  <TextField
                    id='selfUsedWeight'
                    type='number'
                    margin='dense'
                    size='small'
                    label='Self Used Weight'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.selfWeight}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='diamondPrice'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Diamond Price'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    required
                    value={createInvoice.diamondPrice}
                  />
                </ContentBox>

                <ContentBox>
                  <TextField
                    multiline
                    maxRows={4}
                    id='address'
                    type='text'
                    margin='dense'
                    size='small'
                    label='Address'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.address}
                    onChange={(e) => {
                      setCreateInvoice({ ...createInvoice, address: e.target.value });
                    }}
                  />
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='lcgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='L-CGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.lcgstPercentage}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='extraCostCgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Extra-CGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostCgstPercentage}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() !== 'gujarat' && (
                      <TextField
                        id='extraCostIgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Extra-IGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostIgstPercentage}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='lcgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='L-CGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.lcgstValue}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() !== 'gujarat' && (
                      <TextField
                        id='extraCostIgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Extra-IGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostIgstValue}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='extraCostCgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Extra-CGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostCgstValue}
                      />
                    )}
                </ContentBox>
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <InputLabel sx={{ fontSize: '10px' }} id='stateName'>
                  State
                </InputLabel>

                <Select
                  size='small'
                  sx={{ width: '80%', my: 1 }}
                  variant='standard'
                  labelId='stateName'
                  value={createInvoice.state}
                  onChange={handleStateSelect}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200
                      }
                    }
                  }}
                >
                  {indianStates.map(
                    (data, index) =>
                      (data !== 'SEZ' ||
                        createInvoice.orderType.toLocaleLowerCase() === 'job-work') && (
                        <MenuItem value={data} key={index} id={index}>
                          {data}
                        </MenuItem>
                      )
                  )}
                </Select>
                <FormControl variant='standard' size='small' sx={{ my: 1, width: '80%' }}>
                  <InputLabel id='book-number-label'>Book Number</InputLabel>
                  <Select
                    labelId='book-number-label'
                    value={createInvoice.bookNumber}
                    onChange={handleBookNameSelect}
                  >
                    {bookMasterData?.data?.data
                      ?.filter((data) => Number(data.name) <= Number(bookYear))
                      ?.map((data, index) => (
                        <MenuItem value={data.name} key={index} id={index}>
                          {data.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <ContentBox>
                  <TextField
                    id='productPrice'
                    type='number'
                    margin='dense'
                    size='small'
                    label='Product Price'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.productPrice}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='customerId'
                    required
                    type='text'
                    margin='dense'
                    size='small'
                    label='Customer Id'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.customerId}
                    error={dataError.customerIdError}
                    helperText={dataError.customerIdError ? 'Please Select Customer First' : ''}
                  />
                </ContentBox>
                <ContentBox>
                  <TextField
                    id='mobileNumber'
                    type='tel'
                    margin='dense'
                    size='small'
                    label='Mobile Number'
                    InputLabelProps={{ shrink: true }}
                    sx={{ my: 1, width: '80%' }}
                    variant='standard'
                    value={createInvoice.mobileNumber == null ? '' : createInvoice.mobileNumber}
                    onChange={(e) => {
                      setCreateInvoice({ ...createInvoice, mobileNumber: e.target.value });
                    }}
                  />
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='lsgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='L-SGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.lsgstPercentage}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='extraCostSgstPercentage'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Exra-SGST %'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostSgstPercentage}
                      />
                    )}
                </ContentBox>
                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'self' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='lsgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='L-SGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.lsgstValue}
                      />
                    )}
                </ContentBox>

                <ContentBox>
                  {createInvoice.orderType.toLowerCase() === 'job-work' &&
                    createInvoice.state.toLowerCase() === 'gujarat' && (
                      <TextField
                        id='extraCostSgstValue'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Exra-SGST Value'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={createInvoice.extraCostSgstValue}
                      />
                    )}
                </ContentBox>
              </Grid>

              <Grid container>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <ContentBox>
                    <TextField
                      id='quantity'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Quantity'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='outlined'
                      value={createInvoice.quantity}
                      error={dataError.quantityError}
                      helperText={dataError.quantityError ? 'Please Select Order First' : ''}
                    />
                  </ContentBox>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <ContentBox>
                    <TextField
                      id='extraCost'
                      type='number'
                      margin='dense'
                      size='small'
                      label='Extra-Cost'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='outlined'
                      value={createInvoice.extraCost}
                      error={dataError.extraCostError}
                      helperText={dataError.extraCostError ? 'Value cannot be less than 0' : ''}
                    />
                  </ContentBox>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <ContentBox>
                    <TextField
                      id='subtotal'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Sub Total'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='outlined'
                      value={createInvoice.subTotal}
                      error={dataError.subTotalError}
                      helperText={dataError.subTotalError ? 'Please Select Order First' : ''}
                    />
                  </ContentBox>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <ContentBox>
                    <TextField
                      id='total'
                      type='text'
                      margin='dense'
                      size='small'
                      label='Total'
                      InputLabelProps={{ shrink: true }}
                      sx={{ my: 1, width: '80%' }}
                      variant='outlined'
                      value={createInvoice.total}
                      error={dataError.totalError}
                      helperText={dataError.totalError ? 'Please Select Order First' : ''}
                    />
                  </ContentBox>
                </Grid>
              </Grid>
            </Grid>
            {Number(createInvoice.customerId) > 0 && customerRunningOrder.length > 0 && (
              <CustomerRunningOrder
                customerRunningOrder={customerRunningOrder}
                handleCheckboxChange={handleCheckboxChange}
                selectedOrderDetails={selectedOrderDetails}
                setSelectedOrderDetails={setSelectedOrderDetails}
              />
            )}
            <LoadingButton
              onClick={handleSubmit}
              color='primary'
              loading={loading}
              variant='contained'
              sx={{ my: 2, textTransform: 'capitalize' }}
            >
              Create Invoice
            </LoadingButton>
          </StyledCard>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default CreateInvoice;
